import types from '@/vuex/documentos-favoritos/mutations-types'

const mutations = {
  [types.SET_LISTA_FAVORITOS]: (state, payload) => {
    state.listaDeDocumentosFavoritos = payload.listaDeDocumentosFavoritos
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/documentos-favoritos/mutations.js